/* eslint-disable react/prop-types */
import {useState, useRef, useEffect, useCallback} from 'react';
import './ImageBrightnessAndContrast.scss';
import Locale from '../util/Locale';

function ImageBrightnessAndContrast({src, onApply, onCancel, initialContrast = 100, initialBrightness = 100}) {
    const [contrast, setContrast] = useState(initialContrast);
    const [brightness, setBrightness] = useState(initialBrightness);
    const canvasRef = useRef(null);
    const imageRef = useRef(null);

    const applyAdjustments = useCallback(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        const img = imageRef.current;

        if (!img || !canvas) return;

        canvas.width = img.naturalWidth;
        canvas.height = img.naturalHeight;

        ctx.filter = `contrast(${contrast}%) brightness(${brightness}%)`;
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    }, [contrast, brightness]);

    useEffect(() => {
        if (imageRef.current && canvasRef.current) {
            applyAdjustments();
        }
    }, [applyAdjustments]);

    const handleApply = () => {
        const canvas = canvasRef.current;
        const dataUrl = canvas.toDataURL('image/png');
        onApply({
            image: dataUrl,
            width: canvas.width,
            height: canvas.height,
            contrast,
            brightness
        });
    };

    return (
        <div className="image-adjust">
            <div className="preview-container">
                <canvas ref={canvasRef} className="preview-canvas" />
                <img
                    ref={imageRef}
                    src={src}
                    alt="source"
                    crossOrigin="anonymous"
                    style={{display: 'none'}}
                    onLoad={applyAdjustments}
                />
            </div>
            <div className="adjust-controls">
                <div className="control-segment">
                    <span className="control-label">Brightness:</span>
                    <span className="control-value">{brightness}%</span>
                </div>
                <div className="control-segment slider-segment">
                    <input
                        type="range"
                        min="0"
                        max="200"
                        value={brightness}
                        onChange={e => setBrightness(Number(e.target.value))}
                        className="adjust-slider"
                    />
                </div>
                <div className="control-segment">
                    <span className="control-label">Contrast:</span>
                    <span className="control-value">{contrast}%</span>
                </div>
                <div className="control-segment slider-segment">
                    <input
                        type="range"
                        min="0"
                        max="200"
                        value={contrast}
                        onChange={e => setContrast(Number(e.target.value))}
                        className="adjust-slider"
                    />
                </div>
                <div className="control-segment button-segment">
                    <nsemble-button text onClick={onCancel}>
                        {Locale.getText('CANCEL')}
                    </nsemble-button>
                    <nsemble-button text onClick={handleApply}>
                        {Locale.getText('APPLY')}
                    </nsemble-button>
                </div>
            </div>
        </div>
    );
}

export default ImageBrightnessAndContrast;
